import MapConfig from '../config/map_config';
import Config from "../config/constants";
import { perimeterAjaxCall } from './map_ajax';
import mapboxgl from 'mapbox-gl';
import * as turf from '@turf/turf'

document.addEventListener("turbolinks:load", () => {
    if ($("#site_perimeter_selection").length > 0){
        showOrHideMap();
    }
    listenSitePerimeterChange();
})



const initiatePerimeterMap = (coordinates, perimeterId, siteId) => {
    mapboxgl.accessToken = Config.mapboxAccessToken;
    const map = new mapboxgl.Map({
        container: 'perimeter_map',
        style: 'mapbox://styles/sroberts95/ckjssbjs10v9519ozm81mugy9',
        center: coordinates.split(", "),
        zoom: MapConfig.previewStartingZoom,
        minZoom: MapConfig.zoomOutMax,
        maxZoom: MapConfig.zoomInMax
    });
    map.addControl(new mapboxgl.FullscreenControl());
    map.addControl(new mapboxgl.NavigationControl());

    map.on('load', function() {
        perimeterAjaxCall(map, perimeterId, siteId, true, true);
    })
}

function listenSitePerimeterChange() {
    $("#site_perimeter_selection").change(function() {
        showOrHideMap();
    });
}

function showOrHideMap() {
    var new_perimeter = $("#site_perimeter_selection").val();
    var selectedSiteId = document.getElementById('site-perimeter-site-id').value;
    var companyId = document.getElementById('site_company_id').value;
    var perimeterMap = $("#perimeter_map");

    if (new_perimeter != "") {
        // CSS is not sticking from Map.scss for this element, no idea why, doing it manually for now works
        perimeterMap.css('height', '500px');
        perimeterMap.css('width', '500px');
        perimeterMap.css('overflow', 'visible');
        perimeterMap.show();
        $.ajax({
            type: 'GET',
            url: `${Config.apiUrl}geofences/get_perimeter_coordinates?apikey=${Config.apiKey}&perimeter_id=${new_perimeter}&company_id=${companyId}`,
            dataType: 'json',
            success: data => {
                let coordinates = data.coordinates;
                initiatePerimeterMap(coordinates, new_perimeter, selectedSiteId);
            },
            error: data => {
                perimeterMap.hide();
                alert('perimeter for given ID not found');
            }
        })
    } else {
        perimeterMap.hide();
    }
}